import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

const useAuthState = (oktaAuthState, emptyState = {}) => {
  return useMemo(() => isEmpty(oktaAuthState) ? emptyState : oktaAuthState, [oktaAuthState, emptyState])
}

export default useAuthState
